export const version = "1.7.22";
export const channel = "core";
export const gitcommit = "unknown";
